import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams, useHistory } from 'react-router-dom';
import Loader from "../components/Loader";
import Spinner from "../components/Spinner";
import Swal from 'sweetalert2';

function Voucher() {
    const { voucherCode } = useParams();
    const history = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const serverUrl = process.env.REACT_APP_SERVER_URL;

    const [isLoaded, setIsLoaded] = useState(false);
    const [isRunning, setIsRunning] = useState(false);

    const [idProduct, setId] = useState();
    const [productName, setProductName] = useState("");
    const [details, setDetails] = useState("");
    const [price, setPrice] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [timeperiode, setTimeperiode] = useState("");
    const [timeperiodeFrom, setTimeperiodeFrom] = useState("");
    const [timeperiodeTo, setTimeperiodeTo] = useState("");
    const [homePage, setHomePage] = useState("");
    const [voucherStatus, setVoucherStatus] = useState("");
    const [usedOn, setUsedOn] = useState("");

    useEffect(() => {
        async function getVoucherInfos() {
            const token = await getAccessTokenSilently();
            localStorage.setItem("AcccessToken", token);

            const response = await fetch(`${serverUrl}/api/deserved/` + voucherCode, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
            });
            const product = await response.json();
            setProduct(product);
            setIsLoaded(true);
            setIsRunning(false);
        }

        if (voucherCode) {
            getVoucherInfos();
        } else {
            setIsLoaded(true);
            setIsRunning(false);
        }
    }, [voucherCode, getAccessTokenSilently, serverUrl]);

    function setProduct(product) {
        setId(product.id);
        setProductName(product.productName);
        setDetails(product.details);
        setPrice(product.price);
        setImageUrl(product.imageUrl);
        setTimeperiode(product.timeperiode);
        setTimeperiodeFrom(product.timeperiodeFrom ? new Date(product.timeperiodeFrom).toISOString().split("T")[0] : "");
        setTimeperiodeTo(product.timeperiodeTo ? new Date(product.timeperiodeTo).toISOString().split("T")[0] : "");
        setHomePage(product.homePage);
        setVoucherStatus(product.voucherStatus);
        setUsedOn(product.usedOn ? new Date(product.usedOn).toISOString().split("T")[0] : "");
    }

    const checkVerificationCode = async (verificationCode) => {
        try {
            const token = await getAccessTokenSilently();
            localStorage.setItem("AcccessToken", token);

            const response = await fetch(`${serverUrl}/api/deserved/${voucherCode}/${verificationCode}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
            });

            const resultData = await response.json();
            if (resultData.isSuccessful) {
                updateVoucher(verificationCode);
            } else {
                Swal.fire("Ungültig", resultData.message, "error");
            }
        } catch (err) {
            Swal.fire("Fehler", err.message, "error");
        }
    }

    const updateVoucher = async (verificationCode) => {
        try {
            const token = await getAccessTokenSilently();
            localStorage.setItem("AcccessToken", token);

            const response = await fetch(`${serverUrl}/api/deserved/${voucherCode}/${verificationCode}`, {
                method: "PUT",
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
            });

            const resultData = await response.json();
            if (resultData.isSuccessful) {
                Swal.fire("Gültig", resultData.message, "success").then(() => {
                    window.location.reload()
                });
            } else {
                Swal.fire("Fehler", resultData.message, "error");
            }
        } catch (err) {
            Swal.fire("Fehler", err.message, "error");
        }
    }

    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-outline-warning",
            cancelButton: "btn btn-outline-warning"
        },
        buttonsStyling: false
    });

    return (
        <React.Fragment>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Produktdetails</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="content">
                <div className="card card-solid">
                    <Spinner isRunning={isRunning} />

                    {!isLoaded ? <div className="text-center"><Loader /></div> :
                        <div className="container-fluid">
                            <div>
                                <div className="form-group">

                                    {/* Alle Felder anzeigen, aber disabled */}
                                    <div className="row">
                                        <div className="col-md-12 text-center mb-3 mt-3">
                                            {imageUrl && (
                                                <img
                                                    src={imageUrl}
                                                    alt={productName || "Produktbild"}
                                                    style={{ maxWidth: "300px", maxHeight: "300px", objectFit: "contain" }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Produktname</label>
                                            <input type="text" className="form-control" value={productName || ""} disabled />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 col-xs-12">
                                            <label>Benötigte Likes</label>
                                            <input type="number" className="form-control" value={price || ""} disabled />
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <label>Tage</label>
                                            <input type="number" className="form-control" value={timeperiode || ""} disabled />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Produktbeschreibung</label>
                                            <textarea className="form-control" value={details || ""} rows={5} disabled />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 col-xs-12">
                                            <label>Startdatum</label>
                                            <input type="date" className="form-control" value={timeperiodeFrom || ""} disabled />
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <label>Enddatum</label>
                                            <input type="date" className="form-control" value={timeperiodeTo || ""} disabled />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Homepage</label>
                                            {homePage ? (
                                                <a
                                                    href={homePage.startsWith("http://") || homePage.startsWith("https://") ? homePage : `https://${homePage}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="form-control disabled text-break h-auto"
                                                    style={{ backgroundColor: "#e9ecef" }}
                                                >
                                                    {homePage}
                                                </a>
                                            ) : (
                                                <input type="text" className="form-control" value="" disabled />
                                            )}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 col-xs-12">
                                            <label>Status</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={voucherStatus === 0 ? "Gültig" : voucherStatus === 1 ? "Bereits verwendet" : ""}

                                                disabled
                                            />
                                        </div>
                                        {usedOn && (
                                            <div className="col-md-6 col-xs-12">
                                                <label>Verwendet am</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={usedOn}
                                                    disabled
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {voucherStatus === 0 && (
                                    <div className="d-flex justify-content-center mb-3">
                                        <button
                                            id={idProduct + "reached"}
                                            className="btn btn-outline-warning col-md-6"
                                            block="true"
                                            onClick={() => {
                                                swalWithBootstrapButtons.fire({
                                                    title: "Wie lautet die Geheimzahl?",
                                                    icon: "question",
                                                    html: "Der/Die deserver/in hat die Geheimzahl zusammen mit dem QR Code via Email erhalten. <br>Achtung: Nach dem Einlösen wird der Gutschein automatisch entwerted!",
                                                    input: 'number',
                                                    showCancelButton: true,
                                                    closeOnConfirm: false,
                                                    confirmButtonText: "Bestätigen",
                                                    cancelButtonText: "Abbrechen",
                                                    inputPlaceholder: "Geheimzahl hier eingeben!",
                                                    inputValidator: (value) => {
                                                        if (value === "") {
                                                            return "Die Eingabe ist ungültig.";
                                                        }
                                                    }
                                                }).then((result) => {
                                                    if (result.isDismissed) return false; // falls der Benutzer abbricht
                                                    const inputValue = result.value;
                                                    checkVerificationCode(inputValue);
                                                });
                                            }}
                                        >
                                            Einlösen
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </section>
        </React.Fragment>
    );
}

export default Voucher;
